import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const Candidates = ({ size, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={24} size={size}>
    <path
      d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
    />
    <circle
      cx={9}
      cy={7}
      r={4}
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
    />
    <path
      d="M23 21v-2a4 4 0 0 0-3-3.87"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
    />
  </IconBase>
);
